
export const endpoints = {
    loginGoogleAuth: '/api/identity/auth/google',
    getUserInfo: '/api/identity/getUserInfo',
    refreshToken: '/api/identity/refreshcookies',
    logOut: '/api/identity/logout',
    getFarms: '/api/farm/getFarms?clientId={clientId}&tenantId={tenantId}',
    getFarm: '/api/farm/getFarm?id=',
    getFarmsDetails: '/api/farm/getFarmsDetails',
    getFarmProjectsDetails: '/api/farm/getFarmProjectsDetails',
    getFarmActiveProjects: '/api/farm/getFarmActiveProjects?id=',
    getFarmProjects: '/api/farm/getFarmProjects?id={farmId}&activeProjects={activeProjects}',
    getFarmProject: '/api/farm/getFarmProject?id=',
    getFarmActivities: '/api/farm/getFarmActivities',
    editFarm: '/api/farm/editFarm',
    deleteFarm: '/api/farm/deleteFarm?id={farmId}&deletedByUserEmail={deletedByUserEmail}',
    createFarm: '/api/farm/createFarm',
    setFarmActiveStatus: '/api/farm/setFarmActiveStatus',
    getFarmJobTypes: '/api/farm/getFarmJobTypes?clientId=',
    getFarmJobType: '/api/farm/getFarmJobType?id=',
    createFarmProject: '/api/farm/createFarmProject',
    editFarmProject: '/api/farm/editFarmProject',
    finishFarmProject: '/api/farm/finishFarmProject',
    uploadFarmDocument: '/api/farm/uploadFarmDocument',
    getFarmDocuments: '/api/farm/getFarmDocuments?farmId=',
    downloadFarmDocument: '/api/farm/downloadFarmDocument?id=',
    deleteFarmDocument: '/api/farm/deleteFarmDocument?id={id}&deletedByUserEmail={deletedByUserEmail}',
    addFarmProfit: '/api/farm/addFarmProfit',
    editFarmProfit: '/api/farm/editFarmProfit',
    getFarmProfit: '/api/farm/getFarmProfit?id=',
    getFarmExpense: '/api/farm/getFarmExpense?id=',
    addFarmExpense: '/api/farm/addFarmExpense',
    editFarmExpense: '/api/farm/editFarmExpense',
    deleteFarmExpense: '/api/farm/deleteFarmExpense?id={farmExpenseId}&deletedByUserEmail={deletedByUserEmail}',
    deleteFarmProfit: '/api/farm/deleteFarmProfit?id={farmProfitId}&deletedByUserEmail={deletedByUserEmail}',
    getGlobalFarmJobTypes: '/api/farm/getGlobalFarmJobTypes',
    setClientFarmJobTypes: '/api/farm/setClientFarmJobTypes',
    getFarmExpenseTypes: '/api/farm/getFarmExpenseTypes?clientId=',
    getFarmExpenseType: '/api/farm/getFarmExpenseType?id=',
    getGlobalFarmExpenseTypes: '/api/farm/getGlobalFarmExpenseTypes',
    setClientFarmExpenseTypes: '/api/farm/setClientFarmExpenseTypes',
    getFarmProductTypes: '/api/farm/getFarmProductTypes?clientId=',
    getFarmProductType: '/api/farm/getFarmProductType?id=',
    getGlobalFarmProductTypes: '/api/farm/getGlobalFarmProductTypes',
    setClientFarmProductTypes: '/api/farm/setClientFarmProductTypes',
    getEmployeeJobTypes: '/api/workReport/getEmployeeJobTypes?clientId={clientId}&tenantId={tenantId}',
    getEmployeeJobType: '/api/workReport/getEmployeeJobType?id={employeeJobTypeId}&includeJobPriceHistory={includeJobPriceHistory}',
    getEmployeeJobTypesDetails:  '/api/workReport/getEmployeeJobTypesDetails?clientId={clientId}&tenantId={tenantId}',
    editEmployeeJobType: '/api/workReport/editEmployeeJobType',
    deleteEmployeeJobType: '/api/workReport/deleteEmployeeJobType?id={employeeJobTypeId}&deletedByUserEmail={deletedByUserEmail}',
    createEmployeeJobType: '/api/workReport/createEmployeeJobType',
    getEmployees: '/api/employee/getEmployees?clientId={clientId}&tenantId={tenantId}',
    getEmployeesWithActiveLoans: '/api/employee/getEmployeesWithActiveLoans?clientId={clientId}',
    createWorkReport: '/api/workReport/createWorkReport',
    getProducts: '/api/product/getProducts?tenantId=',
    getProductMeasures: '/api/product/getProductMeasures',
    createProduct: '/api/product/createProduct',
    editProduct: '/api/product/editProduct',
    deleteProduct: '/api/product/deleteProduct?id={productId}&deletedByUserEmail={deletedByUserEmail}',
    getProductInventoryCategories: '/api/product/getProductInventoryCategories',
    getProductInventoryCategory: '/api/product/getProductInventoryCategory?id=',
    getWorkReports: '/api/workReport/getWorkReports',
    getWorkReport: '/api/workReport/getWorkReport?workReportId=',
    getDashboardSummary: '/api/dashboard/getSummary',
    getPayrollDetails: '/api/payroll/getPayrollDetails',
    editWorkReport: '/api/workReport/editWorkReport',
    deleteWorkReport: '/api/workReport/deleteWorkReport?id={workReportId}&deletedByUserEmail={deletedByUserEmail}',
    getTenants: '/api/identity/getTenants?clientId=',
    getPaymentTypes: '/api/employee/getPaymentTypes',
    getPayrollsMaster: '/api/payroll/getPayrollsMaster?clientId={clientId}&payrollStatus={payrollStatus}&page={page}&limit={limit}',
    getPayrollMaster: '/api/payroll/getPayrollMaster?id={id}&clientId={clientId}',
    getInProgressPayroll: '/api/payroll/getInProgressPayroll?clientId=',
    createPayroll: '/api/payroll/createPayroll',
    deletePayroll: '/api/payroll/deletePayroll?id={payrollId}&deletedByUserEmail={deletedByUserEmail}',
    approvePayroll: '/api/payroll/approvePayroll',
    addDetailToPayroll: '/api/payroll/addDetailToPayroll',
    removeWorkReportFromCurrentPayroll: '/api/payroll/removeWorkReportFromCurrentPayroll',
    addWorkReportToCurrentPayroll: '/api/payroll/addWorkReportToCurrentPayroll',
    getPayrollMasterForWorkReport: '/api/payroll/getPayrollMasterForWorkReport?workReportId=',
    addEmployeePayment: '/api/payroll/addEmployeePayment',
    removeEmployeePayment: '/api/payroll/removeEmployeePayment?employeeId={employeeId}&payrollMasterId={payrollMasterId}&deletedByUserEmail={deletedByUserEmail}',
    closePayroll: '/api/payroll/closePayroll?id={payrollId}&closedByUserEmail={closedByUserEmail}',
    getEmployeesInformation: '/api/employee/getEmployeesInformation',
    getEmployee: '/api/employee/getEmployee?id=',
    setEmployeeActiveStatus: '/api/employee/setEmployeeActiveStatus',
    getBanks: '/api/employee/getBanks',
    editEmployee: '/api/employee/editEmployee',
    bulkAssignTenant: '/api/employee/bulkAssignTenant',
    getEmployeePaymentHistory: '/api/employee/getEmployeePaymentHistory',
    getEmployeePaymentBreakdown: '/api/employee/getEmployeePaymentBreakdown?paymentId={paymentId}&clientId={clientId}',
    getEmployeeWorkHistory: '/api/employee/getEmployeeWorkHistory',
    createEmployee: '/api/employee/createEmployee',
    getEmployeeBankAccount: '/api/employee/getEmployeeBankAccount?id=',
    getUsersInformation: '/api/identity/getUsersInformation',
    getUser: '/api/identity/getUser?id=',
    setUserActiveStatus: '/api/identity/setUserActiveStatus',
    editUser: '/api/identity/editUser',
    getPermissions: '/api/identity/getPermissions',
    editUserImage: '/api/identity/editUserImage',
    createUser: '/api/identity/createUser',
    getEmployeeLoans: '/api/employee/getEmployeeLoans?id={employeeId}&activeLoans={activeLoans}',
    addEmployeeLoan: '/api/employee/addEmployeeLoan',
    getEmployeeLoan: '/api/employee/getEmployeeLoan?id=',
    getEmployeeLoanPayments: '/api/employee/getEmployeeLoanPayments?employeeLoanId=',
    addEmployeeLoanPayment: '/api/employee/addEmployeeLoanPayment',
    addPayrollDeduction: '/api/payroll/addPayrollDeduction',
    getEmployeeLoanPayment: '/api/employee/getEmployeeLoanPayment?id=',
    getPayrollDeduction: '/api/payroll/getPayrollDeduction?id=',
    deleteEmployeeLoan: '/api/employee/deleteEmployeeLoan?id={id}&deletedByUserEmail={deletedByUserEmail}',
    deleteEmployeeLoanPayment: '/api/employee/deleteEmployeeLoanPayment?id={id}&deletedByUserEmail={deletedByUserEmail}',
    deletePayrollDeduction: '/api/payroll/deletePayrollDeduction?id={id}&deletedByUserEmail={deletedByUserEmail}',
    getPayrollLogs: '/api/payroll/getPayrollLogs?payrollMasterId={payrollMasterId}',
    analyzeInvoice: '/api/invoice/analyzeInvoice',
    getInvoiceDocuments: '/api/invoice/getInvoiceDocuments?tenantId=',
    getInvoiceDocument: '/api/invoice/getInvoiceDocument?id=',
    downloadInvoiceDocument: '/api/invoice/downloadInvoiceDocument?id=',
    applyInvoiceDecisions: '/api/invoice/applyInvoiceDecisions',
    discardInvoiceDocument: '/api/invoice/discardInvoiceDocument?id={id}&updatedByUserEmail={updatedByUserEmail}',
    getSuppliers: '/api/supplier/getSuppliers?tenantId=',
    createSupplier: '/api/supplier/createSupplier',
    getProductInventoryHistory: '/api/product/getProductInventoryHistory?tenantId={tenantId}',
    // Platform area: every route requires the PlatformAdmin policy except platformMe.
    platformMe: '/api/platform/me',
    platformCatalogItems: '/api/platform/catalogs/{catalog}',
    platformCatalogItem: '/api/platform/catalogs/{catalog}/{id}',
    platformCatalogItemActive: '/api/platform/catalogs/{catalog}/{id}/active',
    platformClients: '/api/platform/clients',
    platformClient: '/api/platform/clients/{clientId}',
    platformClientActive: '/api/platform/clients/{clientId}/active',
    platformClientCatalog: '/api/platform/clients/{clientId}/catalogs/{catalog}',
    platformClientContacts: '/api/platform/clients/{clientId}/contacts',
    platformClientContact: '/api/platform/clients/{clientId}/contacts/{id}',
    platformClientTenants: '/api/platform/clients/{clientId}/tenants',
    platformClientTenant: '/api/platform/clients/{clientId}/tenants/{id}',
    platformClientTenantActive: '/api/platform/clients/{clientId}/tenants/{id}/active',
    platformClientAdmins: '/api/platform/clients/{clientId}/admins',
    platformClientAdminActive: '/api/platform/clients/{clientId}/admins/{userId}/active',
    platformAuditLogs: '/api/platform/auditLogs',
}

/** Replaces every `{name}` placeholder of an endpoint template. */
export const buildUrl = (template: string, params: Record<string, string | number>) =>
    Object.entries(params).reduce(
        (url, [key, value]) => url.split(`{${key}}`).join(encodeURIComponent(String(value))),
        template
    )
